import parse from 'html-react-parser'

import { useTranslation } from './use-translation'

import { PromoBannerProps } from 'app/components/blog/PromoBanner/PromoBanner'
import { IPromoBannerAttributes } from 'app/components/blog/PromoBanner/PromoBannerBlock'
import { GIFT_COUPON_URL, PROMO_BANNER_IMAGE_URL } from 'app/parameters'
import { useGlobalState } from 'app/store'

type PromoBannerData = Required<Omit<PromoBannerProps, 'variation'>>

export const usePromoBannerData = (): PromoBannerData => {
  const t = useTranslation()
  const [blocks] = useGlobalState('reusableBlocks')
  const promoBannerBlockData = blocks.get('honeygain-components/promo-banner')
  const promoBannerProps: IPromoBannerAttributes = promoBannerBlockData?.attrs ?? {}

  const defaultPromoBannerProps = {
    title: t('earn_passive_income_effortlessly'),
    description: parse(t('join_honeygain_and_collect_gift')),
    buttonText: t('join_honeygain'),
  }

  return {
    ...defaultPromoBannerProps,
    ...promoBannerProps,
    buttonUrl: promoBannerProps?.url ?? GIFT_COUPON_URL,
    image: promoBannerProps?.mediaUrl ?? PROMO_BANNER_IMAGE_URL,
  }
}
